import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import React from "react";
import {
  Col,
  Container,
  Row,
  Input,
  Button,
  Card,
  CardBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table,
} from "reactstrap";
import find from "../../../assets/find.svg";
import "simplebar/dist/simplebar.min.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import SimpleBar from "simplebar-react";
import Placeholder from "../../../assets/images/Placeholder.gif";
import moreIcon from "../../../assets/images/more.png";
import check from "../../../assets/images/check.svg";
import caldropdown from "../../../assets/images/cal-dropdown.svg";
import { get, del, put } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import { useSelector } from "react-redux";

const BankListing = () => {
  document.title = "Bank Listing | Elevated - Admin Dashboard";
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const gymId = searchParams.get("gymId");

  const [dropdownOpen, setDropdownOpen] = useState({
    selectGym: false,
    dateRange: false,
    byLocation: false,
    mostLoved: false,
  });
  const [bankData, setBankData] = useState([]);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState("");
  const [itemPerPage, setItemPerPage] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [selectedType, setSelectedType] = useState("By Type");
  const [endSearchDate, setEndSearchDate] = useState("");
  const itemsPerPage = 6;
  const [startSearchDate, setStartSearchDate] = useState("");
  const { currentUser } = useSelector((state) => state.auth);

  const [selectedGym, setSelectedGym] = useState("");
  const [gymData, setGymData] = useState([]);
  const [seletedGymId, setSeletedGymId] = useState("");
  const gymIds = async () => {
    const resp = await get(
      `${endpoints.gym}/admin?userId=${currentUser.id}&limit=50`
    );
    if (resp?.data?.success) {
      setGymData(resp.data.data);

      let temp = resp?.data?.data.filter((item) => item._id == gymId);

      setSelectedGym(temp[0]?.name || resp?.data?.data[0]?.name);
      setSeletedGymId(gymId ? gymId : resp?.data?.data[0]?._id);
    }
  };

  useEffect(() => {
    if (
      currentUser.appRole == "gymOwner" ||
      currentUser.appRole == "gymStaff"
    ) {
      gymIds();
    }
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  const toggleDropdown = (passId) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [passId]: !prevState[passId],
    }));
  };

  const fetchPasses = async (page, searchQuery = "") => {
    setLoading(true);
    try {
      const response = await get(
        `${endpoints.bank}/all/${
          gymId != "null" && gymId != null ? gymId : seletedGymId
        }?filter=active&limit=${itemsPerPage}&page=${page}&type=${
          selectedType == "By Type" ? "" : selectedType
        }&search=${searchQuery}&startDate=${startSearchDate}&endDate=${endSearchDate}`
      );

      setBankData(Array.isArray(response.data?.data) ? response.data.data : []);
      setTotalPages(response.data?.totalPages || 1);
      setItemPerPage(response.data?.data?.length || 0);
      setTotalItems(response.data?.totalCount || 0);
    } catch (error) {
      setBankData([]);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const navigate = useNavigate();

  const handleSelectChange = async (action, passId) => {
    switch (action) {
      case "delete":
        await deleteBank(passId);
        break;
      case "update":
        const updatedData = {};
        await updateBank(passId, updatedData);
        break;

      default:
        break;
    }
  };

  const handleEditBank = (passId, gymId) => {
    navigate(`/add-bank?bankId=${passId}&gymId=${gymId}`);
  };

  const deleteBank = async (passId) => {
    try {
      await del(`${endpoints.bank}/${passId}`);
      setBankData((prevData) => prevData.filter((pass) => pass._id !== passId));
      toast.success(`Pass Deleted Successfully`, {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
      fetchPasses(currentPage);
    } catch (error) {}
  };
  const updateBank = async (passId, updatedData) => {
    try {
      await put(`${endpoints.pass}/${passId}`, updatedData);
      fetchPasses(currentPage, searchTerm);
    } catch (error) {}
  };
  const handleBankDetail = async (passId) => {
    try {
      const response = await get(`${endpoints.pass}/${passId}`);
      navigate(`/pass-detail`, { state: { passData: response.data } });
    } catch (error) {}
  };
  const handleClearFilters = () => {
    setSelectedType("By Type");
    setSearchTerm("");
    setCurrentPage(1);
  };
  const handleClearDates = () => {
    setStartDate(null);
    setEndDate(null);
    fetchPasses(1);
  };
  function formatDate(date) {
    try {
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      return new Date(date)
        .toLocaleDateString("en-CA", options)
        .replace(/\//g, "-");
    } catch (err) {
      console.error("Error", err);
    }
  }
  useEffect(() => {
    fetchPasses(currentPage, debouncedSearchTerm);
  }, [currentPage, debouncedSearchTerm, seletedGymId, selectedType]);
  return (
    <div className="">
      <Container fluid>
        <Row>
          <Col>
            <Card className="rounded-4">
              <CardBody>
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
                  {/* Title Section */}
                  <div className="d-flex flex-row justify-content-start align-items-center gap-2 w-100 mt-2 mt-sm-0">
                    <span className="font-size-20 fw-bold primary-black ff-sora mb-2 mb-sm-0">
                      Bank List
                    </span>
                  </div>

                  {/* Dropdown and Button Section */}
                  <div className="d-flex flex-column flex-sm-row justify-content-end align-items-center gap-2 w-100 mt-2 mt-md-0">
                    {/* Gym Dropdown (Conditional) */}
                    {(currentUser.appRole === "gymOwner" ||
                      currentUser.appRole === "gymStaff") && (
                      <div className="d-flex flex-xs-row gap-2 w-100 w-sm-auto">
                        <Dropdown
                          isOpen={dropdownOpen.selectGym}
                          toggle={() => toggleDropdown("selectGym")}
                          className="w-100 w-sm-auto"
                        >
                          <DropdownToggle
                            caret
                            className="filter-btn d-flex justify-content-between align-items-center  w-100 w-xs-auto"
                          >
                            <span className=" w-100 w-xs-auto">
                              {selectedGym}
                              <small style={{ fontSize: "9px" }}>
                                (Selected GYM)
                              </small>
                            </span>
                            <img src={check} alt="Location" className="ms-2" />
                          </DropdownToggle>
                          <DropdownMenu style={{ zIndex: 1 }}>
                            {gymData.map((item, index) => (
                              <DropdownItem
                                key={index}
                                className="fw-normal ff-sora secondary-black font-size-14"
                                onClick={() => {
                                  setSelectedGym(item.name);
                                  setSeletedGymId(item._id);
                                }}
                              >
                                {item.name}
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        </Dropdown>
                      </div>
                    )}

                    {/* Add New Button (Conditional) */}
                    {currentUser.userPermissions?.passes?.["Create Pass"] && (
                      <Button
                        className="rounded-pill w-auto w-sm-100" // Full width on small screens, auto width on larger screens
                        style={{ minWidth: "120px" }} // Compact width on larger screens
                        onClick={() => {
                          navigate(
                            `/add-bank?gymId=${
                              gymId != null ? gymId : seletedGymId
                            }`
                          );
                        }}
                      >
                        Add New
                      </Button>
                    )}
                  </div>
                </div>

                <div
                  className="table-responsive hide-scrollbar rounded-4"
                  style={{
                    height: bankData?.length > 0 ? "500px" : "auto",
                  }}
                >
                  <Table
                    hover
                    className="table-borderless table-centered table-nowrap"
                  >
                    <thead>
                      <tr>
                        <th className="primary-black fw-bold ff-sora font-size-14">
                          Bank ID
                        </th>
                        <th className="primary-black fw-bold ff-sora font-size-14">
                          Name On Account
                        </th>
                        <th className="primary-black fw-bold ff-sora font-size-14">
                          Rounting Number
                        </th>
                        <th className="primary-black fw-bold ff-sora font-size-14">
                          Account Number
                        </th>
                        <th className="primary-black fw-bold ff-sora font-size-14">
                          Account Type
                        </th>
                        <th className="primary-black fw-bold ff-sora font-size-14">
                          Status
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan={8} className="text-center">
                            <div className="d-flex justify-content-center align-items-center">
                              <div
                                className="spinner-border"
                                style={{
                                  width: "3rem",
                                  height: "3rem",
                                  color: "#3BABA6",
                                }}
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : bankData.length === 0 ? (
                        <></>
                      ) : (
                        bankData.map((pass, index) => (
                          <tr key={pass._id}>
                            <td className="fw-normal ff-sora secondary-black font-size-14">
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </td>
                            <td className="fw-normal ff-sora secondary-black font-size-14 text-capitalize">
                              {pass.nameOnAccount || "N/A"}
                            </td>
                            <td className="fw-normal ff-sora secondary-black font-size-14">
                              {pass?.routingNumber?.$numberDecimal
                                ? pass?.routingNumber?.$numberDecimal
                                : "N/A"}
                            </td>
                            <td className="fw-normal ff-sora secondary-black font-size-14">
                              <span>
                                {pass?.accountNumber?.$numberDecimal
                                  ? pass?.accountNumber?.$numberDecimal
                                  : "N/A"}
                              </span>
                            </td>
                            <td className="fw-normal ff-sora secondary-black font-size-14 text-capitalize">
                              {pass?.accountType}
                            </td>
                            <td className="fw-normal ff-sora secondary-black font-size-14">
                              {pass.setPrimary ? "Active" : "Unactive"}
                            </td>
                            <td>
                              {/* Dropdown for each pass */}
                              <Dropdown
                                isOpen={dropdownOpen[pass._id]}
                                toggle={() => toggleDropdown(pass._id)}
                                direction="down"
                              >
                                <DropdownToggle
                                  tag="button"
                                  className="btn btn-link p-0"
                                >
                                  <img src={moreIcon} alt="More options" />
                                </DropdownToggle>
                                <DropdownMenu end>
                                  <DropdownItem
                                    className="fw-normal ff-sora secondary-black font-size-14"
                                    onClick={() =>
                                      handleEditBank(pass._id, pass.gymId)
                                    }
                                  >
                                    Edit Bank
                                  </DropdownItem>

                                  <DropdownItem
                                    className="fw-normal ff-sora secondary-black font-size-14"
                                    onClick={() =>
                                      handleSelectChange("delete", pass._id)
                                    }
                                  >
                                    Delete Bank
                                  </DropdownItem>

                                  {/* <DropdownItem
                                      className="fw-normal ff-sora secondary-black font-size-14"
                                      onClick={() => handleBankDetail(pass._id)}
                                    >
                                      Bank Detail
                                    </DropdownItem> */}
                                </DropdownMenu>
                              </Dropdown>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                  {!loading && bankData.length === 0 && (
                    <div className="d-flex flex-column align-items-center justify-content-center vh-50">
                      <img
                        src={Placeholder}
                        alt="No record placeholder"
                        className="object-fit-contain img-fluid h-25 w-25 rounded-3 mb-3"
                      />
                      <p className="mt-3 ff-sora font-size-16 fw-normal">
                        No Record Found!
                      </p>
                    </div>
                  )}
                </div>
              </CardBody>
            </Card>

            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "40px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
                backgroundColor: "#f5f5f5",
              }}
            >
              <div>
                <span className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                  {`Showing ${Math.min(
                    (currentPage - 1) * itemsPerPage + itemPerPage
                  )} of ${totalItems}`}
                </span>
              </div>
              <div className="d-flex justify-content-center">
                <Button
                  style={{
                    width: "40px",
                    height: "40px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor: currentPage === 1 ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &lt;
                </Button>
                {[...Array(totalPages).keys()]
                  .slice(
                    Math.max(0, currentPage - 2),
                    Math.min(totalPages, currentPage + 1)
                  )
                  .map((page) => (
                    <Button
                      key={page + 1}
                      onClick={() => handlePageChange(page + 1)}
                      style={{
                        width: "40px",
                        height: "40px",
                        color: currentPage === page + 1 ? "white" : "#1f1f1f",
                        background:
                          currentPage === page + 1 ? "#3BABA6" : "#f5f5f5",
                        marginLeft: "10px",
                        marginRight: "10px",
                        borderRadius: "80px",
                        border: 0,
                      }}
                      className={currentPage === page + 1 ? "active" : ""}
                    >
                      {page + 1}
                    </Button>
                  ))}
                <Button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    width: "40px",
                    height: "40px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor:
                      currentPage === totalPages ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                >
                  &gt;
                </Button>
              </div>
            </div>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "60px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
              }}
            ></div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BankListing;
